import { mediaItems } from '@/mocks/homeData';

export default function MediaCards() {
  return (
    <section id="media" className="py-12 md:py-16 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="section-title">吃瓜视频</h2>
          <p className="section-subtitle">热门事件视频速览，快速了解今日大瓜</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group bg-white rounded-xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors"></div>
                <div className="absolute bottom-2 right-2 bg-black/70 text-white text-xs px-2 py-0.5 rounded">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform shadow-lg">
                    <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <span className="inline-block text-xs font-medium text-primary-500 bg-primary-50 px-2 py-0.5 rounded mb-2">
                  {item.category}
                </span>
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1 mt-2 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  <span>{item.views}次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}